<div class="flex flex-col basis-full">
  <div class="flex flex-row display">
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" [matDialogClose]="false"></mat-icon>
    <div class="flex flex-col items-center mb-10">
      <mat-icon svgIcon="warning_amber" class="w-36 h-36 amber_color"></mat-icon>
      <div *ngIf="title" class="fw-700 fs-24 failed-title mt-10 mb-10">{{title}}</div>
    </div>
    <div class="message fw-500 mr-24 mb-24">
      {{message}}
    </div>
    <div class="flex justify-center mt-12">
      <button class="accent report-letter-spacing" type="button" (click)="onSupportClick()"> {{ 'BUTTONS.CREATE_TICKET' | transloco }} </button>
    </div>
  </div>
</div>
